<template>
  <footer class="footer px-0">
    <v-card color="primary" flat tile class="card-box">
      <template v-if="false">
        <v-card-text class="text-center">
          <v-btn
            v-for="si in socialIcons"
            :key="si.url"
            class="mx-4 white--text"
            icon
            :href="si.url"
            target="_blank"
          >
            <v-icon size="24px" v-text="si.icon" />
          </v-btn>
        </v-card-text>
      </template>

      <div fluid class="py-1 px-3">
        <v-row>
          <!-- Social -->
          <v-col cols="12" md="12" lg="2" class="text-center">
            <a href="https://westore.ai">
              <v-img
                eager
                alt="WeStore"
                class="shrink mr-2 d-inline-block"
                :src="
                  isRtl
                    ? require('../assets/WeStore_logo-white-footer-arabic-w208.png')
                    : require('../assets/WeStore_logo-white-footer-w208.png')
                "
                transition="scale-transition"
                width="208"
              />
            </a>

            <div class="d-flex">
              <v-btn
                v-for="si in socialIcons"
                :key="si.url"
                class="mx-1 white--text"
                icon
                :href="si.url"
                target="_blank"
              >
                <v-icon size="24px" v-text="si.icon" />
              </v-btn>
            </div>
          </v-col>
          <!-- Data -->
          <v-col
            cols="12"
            md="3"
            :lg="fl.cols || 2"
            v-for="fl in footerLinks"
            :key="fl.head.title"
          >
            <v-list dense color="primary" class="white--text">
              <v-list-item-group>
                <!-- Column Head -->
                <v-list-item :href="fl.head.url" target="_blank">
                  <h3 v-text="$t(fl.head.title)" class="white--text" />
                </v-list-item>
                <!-- Column Items -->
                <v-list-item
                  v-for="fll in fl.links"
                  :key="fll.title"
                  :to="fll.to || null"
                  :href="fll.url || null"
                  @click="fll.action ? fll.action() : false"
                  class="white--text"
                  target="_blank"
                >
                  <v-list-item-icon class="hidden-md-and-down" v-if="fll.icon">
                    <v-icon
                      class="white--text"
                      :class="isRtl ? 'ml-4' : ''"
                      v-text="fll.icon"
                    />
                  </v-list-item-icon>
                  <v-list-item-content>
                    {{ $t(fll.title) }}
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </div>

      <v-divider light></v-divider>

      <v-card-text
        class="white--text text-center ws-black xdarken-1"
        @click="globals.interestDialog = true"
      >
        <strong
          >© {{ $t(new Date().getFullYear()) }}
          {{ $t("WeStore.ai. All Rights Reserved") }}</strong
        >
      </v-card-text>
    </v-card>

    <!-- WHATSAPP -->
    <!-- <ws-whatsapp-popup /> -->
  </footer>
</template>

<script>
import mixins from "vue-typed-mixins";
import MyMixin, { globals } from "../plugins/myMixin";
import wsWhatsappPopup from "./ws-whatsapp-popup.vue";

export default mixins(MyMixin).extend({
  components: { wsWhatsappPopup },
  name: "ws-footer",
  data() {
    return {
      socialIcons: [
        { url: "https://facebook.com/WeStoreAi", icon: "mdi-facebook" },
        { url: "https://www.instagram.com/westore.ai", icon: "mdi-instagram" },
        { url: "https://www.twitter.com/westoretech", icon: "mdi-twitter" },
        {
          url: "https://www.linkedin.com/company/westore-ai/",
          icon: "mdi-linkedin",
        },
      ],
      footerLinks: [
        // Company
        {
          head: { title: "Company", url: "https://westore.ai" },
          links: [
            { title: "About", url: "https://westore.ai/about" },
            { title: "Career", url: "https://westore.ai/about#career" },
            {
              title: "Terms of Service",
              url: "https://westore.ai/terms-of-service",
            },
            {
              title: "Privacy Policy",
              url: "https://westore.ai/privacy-policy",
            },
          ],
        },
        //   Services
        {
          head: {
            title: "Services",
            url: "https://westore.ai/terms-of-service",
          },
          links: [
            { title: "Storage", url: "https://westore.ai/services#storage" },
            {
              title: "Fulfillment",
              url: "https://westore.ai/services#fulfillment",
            },
            {
              title: "Delivery",
              url: "https://westore.ai/services#delivery",
            },
            {
              title: "Returns",
              url: "https://westore.ai/services#returns",
            },
            {
              title: "Customer Service",
              url: "https://westore.ai/services#customer-service",
            },
          ],
        },
        //   Resources
        {
          head: { title: "Resources", url: "https://westore.ai/help#help" },
          links: [
            { title: "Help", url: "https://westore.ai/help" },
            { title: "FAQs", url: "https://westore.ai/faqs" },
            {
              title: "Schedule a Demo",

              action: () => {
                globals.interestDialog = true;
              },
            },
            {
              title: "List Your Warehouse",
              url: "https://westore.ai/warehouse#list-your-warehouse",
            },
          ],
        },
        //   Contact
        {
          cols: "3",
          head: { title: "Contact", to: { name: "Contact" } },
          links: [
            {
              title: globals.contactPoints.phone.text,
              icon: globals.contactPoints.phone.icon,
              url: globals.contactPoints.phone.href,
            },
            {
              title: globals.contactPoints.email.text,
              icon: globals.contactPoints.email.icon,
              url: globals.contactPoints.email.href,
            },
            {
              title: globals.contactPoints.stAddress.text,
              icon: globals.contactPoints.stAddress.icon,
              url: globals.contactPoints.stAddress.href,
            },
          ],
        },
      ],
    };
  },
  mounted() {},
});
</script>
<style scoped lang="scss">
.card-box {
  width: 100%;
}
</style>
